<template>
  <v-dialog v-model="isOpen" max-width="600px" scrollable>
    <v-card>
      <v-card-title class="justify-center" cols="12">
        <h2>
          Редактирование пароля
        </h2>
      </v-card-title>
      <v-card-text style="height: 65%;">
        <v-col
            cols="12"
        >
          <ValidationObserver ref="validationObserverPass" v-slot="{ handleSubmit }">
              <v-col
                  cols="12"
              >
                <ValidationProvider
                    v-slot="{ errors }"
                    name="старый пароль"
                    rules="required|max:96"
                >
                  <v-text-field
                      v-model="oldPassword"
                      :error-messages="errors"
                      label="Старый пароль"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            <v-col
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="новый пароль"
                  rules="required|max:96"
              >
                <v-text-field
                    v-model="newPassword"
                    :error-messages="errors"
                    label="Новый пароль"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col
                cols="12"
            >
              <ValidationProvider
                  v-slot="{ errors }"
                  name="повторите новый пароль"
                  :rules="{required: true, max:96, repass: newPassword}"
              >
                <v-text-field
                    v-model="replyPassword"
                    :error-messages="errors"
                    label="Повторите новый пароль"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="alert">
              <v-alert
                  dense
                  icon="mdi-alert"
                  outlined
                  type="error"
                  :value="alert"
              >
                {{ errorText }}
              </v-alert>
            </v-col>
            <v-row justify="end">
              <v-spacer />
              <v-btn
                  class="mr-2"
                  color="blue darken-1"
                  text
                  @click="close"
                  :disabled="disabled"
              >
                Закрыть
              </v-btn>
              <v-btn
                  color="primary"
                  @click.prevent="handleSubmit(save)"
                  :disabled="disabled"
              >
                Сохранить
              </v-btn>
            </v-row>
          </ValidationObserver>
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'PasswordEditor',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: Boolean,
  },
  data () {
    return {
      newPassword: '',
      oldPassword: '',
      replyPassword: '',
      disabled: false,
      alert: false,
      errorText: '',
    }
  },
  computed: {
    isOpen: {
      get () {
        return this.value
      },
      set (value) {
        this.$refs.validationObserverPass.reset();
        this.$emit('input', value)
      },
    },
  },
  methods: {
    close () {
      this.isOpen = false
      this.$emit('on-close')
    },
    async save() {
      this.disabled = true
      try {
        // await this.$store.dispatch('users/checkCurrentPassword', { currentPassword: 'fake' })

        await this.$store.dispatch('users/changePassword', { oldPassword: this.oldPassword, newPassword: this.newPassword })
        this.$toasted.success('Успешно сохранено')
        this.disabled = false
        this.isOpen = false
        this.errorText = ''
        this.alert = false
        this.$emit('on-save', this.item)
      } catch (err) {
        this.$toasted.error('Что то пошло не так')
        if (err.response.status === 403) {
          this.alert = true
          this.errorText = err.response.data
        }
        this.disabled = false
      }
    }
  }
}
</script>

<style scoped>

</style>
